import { Place } from 'wdc-cube';
/**
 * Os places: os pontos do cubo, preenchidos por `initializeRoutes` (ver `routes.ts`).
 *
 * ## Onde moram os NOMES de parametro e de atributo
 *
 * Nao aqui. Cada `xxx.key.ts` declara os nomes que le e escreve, numa tabela local
 * (`P` para parametros, `A` para atributos), e todo nome comeca pelo PREFIXO de duas
 * letras daquele arquivo (`const PREFIX = 'co'` em `collaborators.key.ts`). O prefixo
 * e unico na aplicacao; o codigo local, unico dentro do arquivo.
 *
 * A razao e a do ciclo do cubo: uma tentativa de virar a face passa o MESMO intent
 * por todos os `applyParameters` do caminho, e pode desviar ou voltar no meio. Dois
 * donos com o mesmo nome sobrescrevem um ao outro nesse percurso. Com o prefixo, a
 * unicidade global vira uma decisao por arquivo - e acrescentar um nome so exige olhar
 * o proprio arquivo. Nos modulos genericos, cada ponto de montagem tem a sua keys, e
 * portanto nomes proprios.
 *
 * Antes havia aqui uma tabela global (`ParamIds`/`AttrIds`) que ninguem consultava ao
 * nomear: `CompanyId` acabou com dois donos (Colaboradores e Relatorio de Sono), e
 * escolher a empresa num filtrava o outro. `url-codes.test.ts` guarda a regra nova.
 *
 * Os slots de composicao (`parentSlot`, `dialogSlot`) moram em `main.key.ts`, e sao
 * a unica reutilizacao deliberada de nome: cada nivel assume a paternidade visual e
 * reescreve a MESMA entrada para o nivel seguinte se encaixar onde ele determinar.
 */
export const Places = {
    main: Place.ROOT,
    /**
     * A pagina que VENDE o produto.
     *
     * Publica, e o destino de quem chega sem sessao. A porta continua sendo
     * `signIn`: quem foi BARRADO numa tela interna quer entrar, nao ler propaganda.
     */
    landing: Place.UNKNOWN,
    /** O conceito da conta - passagem; quem para nele cai no login. */
    account: Place.UNKNOWN,
    signIn: Place.UNKNOWN,
    /**
     * As tres telas publicas que acompanham a porta.
     *
     * Ficam fora do `hub` pelo mesmo motivo que `sign-in`: quem as procura nao tem
     * sessao. `app-delete-account` e alcancada so por link de fora - e exigencia
     * das lojas de aplicativo, e nao aparece em menu nenhum.
     */
    forgotPassword: Place.UNKNOWN,
    appDeleteAccount: Place.UNKNOWN,
    /**
     * O HUB: tudo o que exige sessao fica dentro dele.
     *
     * Existe para a porta ser verificada UMA vez, no lugar que a possui. Uma tela
     * de dentro nao roda para depois descobrir que nao devia ter rodado - e o
     * presenter que retorna `false` interrompe a caminhada antes disso.
     */
    hub: Place.UNKNOWN,
    dashboard: Place.UNKNOWN,
    /**
     * O CONCEITO, e a listagem dentro dele.
     *
     * `collaborators` nao desenha: e passagem, e quem para nele cai em
     * `collaboratorList`. Os dois existem porque o detalhe e IRMAO da listagem, e
     * nao filho - ver `ConceptScope`.
     */
    collaborators: Place.UNKNOWN,
    collaboratorList: Place.UNKNOWN,
    /*
     * O detalhe do paciente e o MESMO apresentador, montado em dois lugares.
     *
     * Sao dois places porque sao dois pontos da arvore, e o `Application` indexa
     * presenter por `place.id` - cada montagem tem a sua instancia, e o "Voltar" de
     * cada uma cai na lista que a hospeda, com os filtros dela vivos. O admin chega
     * pelo de baixo, o profissional pelo de cima; nunca os dois ao mesmo tempo, e e
     * isso que permite as duas publicarem os mesmos nomes de parametro.
     */
    collaboratorDetail: Place.UNKNOWN,
    monitoringDetail: Place.UNKNOWN,
    companies: Place.UNKNOWN,
    companyUsers: Place.UNKNOWN,
    companyUserForm: Place.UNKNOWN,
    companyUserDetail: Place.UNKNOWN,
    companyEdit: Place.UNKNOWN,
    companyConfirm: Place.UNKNOWN,
    monitoring: Place.UNKNOWN,
    monitoringList: Place.UNKNOWN,
    sharedHistory: Place.UNKNOWN,
    myData: Place.UNKNOWN,
    userBase: Place.UNKNOWN,
    sleepReport: Place.UNKNOWN,
    icp: Place.UNKNOWN
};
//# sourceMappingURL=route-consts.js.map